<template>
  <div>
    <customs-header back-route="/customize" />
    <main class="min-h-screen f-col">
      <section class="grow bg-grey-90">
        <cms-section v-if="eSpots?.['top-of-page']" page-context :section="eSpots?.['top-of-page']" />
        <h1 class="mt-6 title-1 font-primary uppercase container" style="font-weight: 700">
          {{ data?.title }}
        </h1>
        <base-grid class="mt-8 container" :cols="{ sm: 1, md: 2, lg: 3 }" gap="lg">
          <div
            v-for="({ name, src, description, basePrice, upgradePrice, to }, key) in models"
            :key
            class="group relative f-col rounded bg-white p-4 text-center"
          >
            <base-link class="group-@hactive:c-brand-3" :to>
              <h2 v-html="name" class="title-3 uppercase" style="padding-inline: 4rem" />
              <base-picture height="122" :src width="193" />
            </base-link>
            <div v-html="description" class="grow content-center py-8 text-center text-sm" />
            <vf-button class="w-full" :to>
              <span class="absolute-0 z-1" />
              {{ getPriceString(basePrice, upgradePrice) }}
            </vf-button>
          </div>
        </base-grid>
        <cms-section v-if="eSpots?.['bottom-of-page']" page-context :section="eSpots?.['bottom-of-page']" />
      </section>
    </main>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({ layout: false })
const { $feature, $formatPrice, $t } = useNuxtApp()

const { data, error } = await useApi().internal.getStaticPage('customs-models')
if (!data.value) throw createError({ ...error.value!, fatal: true })

const { model } = useRoute().params

const eSpots = (await useCms().getSections.generic(`${model}`)).data.value?.content.sectionsMap

const models = computed(() =>
  data.value?.models[`${model}`].filter(({ removeStyle }) => $feature.removeCustomizeStyles ? !removeStyle : true)
)

const getPriceString = (basePrice, upgradePrice) => {
  const priceList = (upgradePrice || basePrice).split('-')
  const formattedPrice = priceList.map((price) => $formatPrice(+price, useCurrencyCode())).join('-')

  return upgradePrice
    ? `${$t.customs.upgrade} + ${formattedPrice}`
    : formattedPrice
}
</script>
